export function LoginPage() {
  return (
    <main className="flex h-full flex-col items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <h2 className="text-center text-[20px] font-semibold text-text-1">Sign in</h2>
        <p className="mt-2 text-center text-[14px] text-text-3">
          Editors are added by an admin. Use the credentials they sent you.
        </p>
        {/* Phase 1.5 wires the actual form; this is a placeholder. */}
        <div className="mt-8 rounded-lg border border-line-2 bg-surface-1 p-5 text-center text-[12px] text-text-4 shadow-[var(--shadow-elev-1)]">
          Login form lands in Phase 1.
        </div>
      </div>
    </main>
  );
}
